/* ============================================================
   MyPokea — Ma Collection (multi-catégories : 9 gens + spéciales)
   - réservé aux clients Shopify connectés (window.MYPOKEA_CUSTOMER)
   - owned set keyed "catId:itemId", persisté par client
   - les achats du site (SKU = clé de collection) sont fusionnés
   - global progress + per-category progress + filters
   ============================================================ */

function _altStd(name, num) {
  const parts = ['Finger puppet', 'Figurine Pokémon', 'Pokémon Kids', name || ''];
  if (num != null) parts.push('N°' + String(num).padStart(3, '0'));
  return parts.join(' | ');
}

/* Vraie photo produit du site, jamais un sprite officiel. */
const GENERIC_REAL_FALLBACK_IMG = "https://cdn.shopify.com/s/files/1/0972/9173/1277/files/Pokemon-Bulbizarre-Bulbasaur-Bisasam-001-figurine-finger-puppet-v4.webp?v=1782133857";

const OWNED_BASE = "mypokea-owned-v2";
const OWNED_BACKUP = "mypokea-owned-bak";   // clé de backup silencieuse
const OLD_OWNED_KEY = "mypokea-owned-v1";
const COL_INTRO_KEY = "mypokea-col-intro-v1";

/* Double index depuis les titres produits :
   1) mot→url  : NOM PRINCIPAL uniquement (avant "avec"/"N°"/"—") pour éviter que
      "Pikachu avec Bulbizarre N°25" indexe "bulbizarre" → image Pikachu
   2) num→url  : N°XXX présent sur (quasi) tous les produits */
const _SPECIAL_TITLE_RE = /brillant|brillante|shiny|chromatique|transparent|cristal|m[eé]ga|gigamax|gigantamax|ultra-chim[eè]re|t[eé]rastal/i;
const _GEN_RAW_KEY = { g1:'KANTO', g2:'JOHTO', g3:'HOENN', g4:'SINNOH', g5:'UNYS', g6:'KALOS', g7:'ALOLA', g8:'GALAR', g9:'PALDEA' };
// Pokémon à tuiles multiples en mode normal (plusieurs formes commerciales distinctes)
const MULTI_FORM_NUMS = new Set([]); // réservé — actuellement géré dans pokedex.js
const _STOP_WORDS = new Set(['figurine','pokemon','pokémon','finger','puppet','kids','figure','marionnette','doigt','bandai','tomy']);
let _wordToImg = null;
let _numToImg  = null;

function _colNorm(s) {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[♀♂]/g, '').toLowerCase();
}

function _primaryNames(title) {
  let t = title.replace(/N[°º]\s*\d+.*/i, '').replace(/\s*[—–]\s*.*/g, '');
  t = t.replace(/\s+avec\s+.*/i, '');
  return t.split('/').flatMap(part =>
    _colNorm(part.trim()).split(/[\s\-]+/).filter(w => w.length >= 3 && !_STOP_WORDS.has(w))
  );
}

function _buildMaps() {
  if (_wordToImg) return;
  _wordToImg = new Map();
  _numToImg  = new Map();
  const all = [
    ...(window.KANTO_PRODUCTS_RAW  || []),
    ...(window.JOHTO_PRODUCTS_RAW  || []),
    ...(window.HOENN_PRODUCTS_RAW  || []),
    ...(window.SINNOH_PRODUCTS_RAW || []),
    ...(window.UNYS_PRODUCTS_RAW   || []),
    ...(window.KALOS_PRODUCTS_RAW  || []),
    ...(window.ALOLA_PRODUCTS_RAW  || []),
    ...(window.GALAR_PRODUCTS_RAW  || []),
    ...(window.PALDEA_PRODUCTS_RAW || []),
  ];
  for (const p of all) {
    if (!p.i || _SPECIAL_TITLE_RE.test(p.t)) continue;
    for (const w of _primaryNames(p.t)) {
      if (!_wordToImg.has(w)) _wordToImg.set(w, p.i);
    }
    const m = p.t.match(/N[°º]\s*0*(\d+)/);
    if (m) {
      const n = parseInt(m[1], 10);
      if (n > 0 && !_numToImg.has(n)) _numToImg.set(n, p.i);
    }
  }
}

function _colFindImg(label, num) {
  _buildMaps();
  const normalized = _colNorm(label).trim();
  const direct = _wordToImg.get(normalized);
  if (direct) return direct;
  for (const w of normalized.split(/\s+/).filter(w => w.length >= 3)) {
    const img = _wordToImg.get(w);
    if (img) return img;
  }
  return (num > 0 ? _numToImg.get(num) : null) || null;
}

function _fetchKantoPage2() {
  const handles = ['kanto', 'gen-1', 'kanto-region'];
  (async () => {
    for (const h of handles) {
      try {
        const r = await fetch(`/collections/${h}/products.json?limit=250&page=2&sort_by=title`);
        if (!r.ok) continue;
        const { products = [] } = await r.json();
        if (!products.length) continue;
        const raw = window.KANTO_PRODUCTS_RAW || [];
        for (const p of products) {
          if (_SPECIAL_TITLE_RE.test(p.title)) continue;
          const img = p.images && p.images[0] ? p.images[0].src : null;
          if (!img) continue;
          raw.push({ t: p.title, i: img, id: p.id });
          for (const v of p.variants || []) {
            if (v.sku && window.GEN_IMGS) window.GEN_IMGS[v.sku] = img;
          }
        }
        window.KANTO_PRODUCTS_RAW = raw;
        _wordToImg = null; _numToImg = null;
        _invalidateCollectionCaches();
        renderCatStrip(); updateTotals(); renderGrid();
        break;
      } catch {}
    }
  })();
}

function _fetchGenPage2(genKey, handle) {
  (async () => {
    try {
      const r = await fetch(`/collections/${handle}/products.json?limit=250&page=2&sort_by=title`);
      if (!r.ok) return;
      const { products = [] } = await r.json();
      if (!products.length) return;
      const raw = window[genKey + '_PRODUCTS_RAW'] || [];
      const existing = new Set(raw.map(p => p.t));
      for (const p of products) {
        if (_SPECIAL_TITLE_RE.test(p.title)) continue;
        const img = p.images && p.images[0] ? p.images[0].src : null;
        if (!img || existing.has(p.title)) continue;
        raw.push({ t: p.title, i: img, id: p.id });
        existing.add(p.title);
        for (const v of p.variants || []) {
          if (v.sku && window.GEN_IMGS) window.GEN_IMGS[v.sku] = img;
        }
      }
      window[genKey + '_PRODUCTS_RAW'] = raw;
      _wordToImg = null; _numToImg = null;
      _invalidateCollectionCaches();
      renderCatStrip(); updateTotals(); renderGrid();
    } catch {}
  })();
}

function _buildAllProductsRaw() {
  const seen = new Set();
  const result = [];
  // id de catégorie (CATS) associé à chaque tableau brut — permet en mode Détaillée
  // de filtrer un onglet spécial (Shiny, Gigamax...) sur SES produits uniquement,
  // plutôt que sur toutes les formes du Pokémon (déjà fait pour les générations).
  // IMPORTANT : les catégories spéciales passent AVANT les générations. Beaucoup de
  // produits spéciaux sont aussi rangés dans une collection de génération côté
  // Shopify (ex. les 16 figurines Gigamax sont TOUTES aussi dans la collection
  // Galar, même Pikachu/Dracaufeu qui sont de Kanto) — si les générations étaient
  // dédupliquées en premier, elles "volaient" systématiquement ces produits et
  // l'onglet spécial se retrouvait vide (constaté : Gigamax affichait 0 résultat).
  const arrays = [
    [window.SHINY_PRODUCTS_RAW,  'shiny'],  [window.GIGAMAX_PRODUCTS_RAW, 'gmax'],
    [window.PIKACHU_PRODUCTS_RAW, 'pikachu'], [window.TRANSPARENTES_PRODUCTS_RAW, 'crystal'],
    [window.TERASTAL_PRODUCTS_RAW, 'teracristal'], [window.MEGAEVO_PRODUCTS_RAW, 'mega'],
    [window.ULTRABEAST_PRODUCTS_RAW, 'ultra'], [window.DRESSEURS_PRODUCTS_RAW, 'trainers'],
    [window.KANTO_PRODUCTS_RAW,  'g1'], [window.JOHTO_PRODUCTS_RAW, 'g2'],
    [window.HOENN_PRODUCTS_RAW,  'g3'], [window.SINNOH_PRODUCTS_RAW, 'g4'],
    [window.UNYS_PRODUCTS_RAW,   'g5'], [window.KALOS_PRODUCTS_RAW, 'g6'],
    [window.ALOLA_PRODUCTS_RAW,  'g7'], [window.GALAR_PRODUCTS_RAW, 'g8'],
    [window.PALDEA_PRODUCTS_RAW, 'g9'],
  ];
  for (const [arr, srcCat] of arrays) {
    for (const p of (arr || [])) {
      if (!p.i) continue;
      // Uniquement pour les sections Gigamax et Teracristal : les coffrets
      // ("Boite Pokémon Gigamax...", "Boite Terastal Pokémon Kids...") ne doivent
      // pas y apparaître, seules les figurines. On ne les marque pas "seen" ici :
      // le même produit retombera normalement sous sa génération (où il est aussi
      // listé côté Shopify) au lieu de disparaître.
      if ((srcCat === 'gmax' || srcCat === 'teracristal') && /bo[iî]te/i.test(p.t)) continue;
      // Déduplique par titre + image, pas par titre seul : plusieurs vraies fiches
      // Shopify distinctes (SKU et stock différents — ex. unités individuelles
      // d'occasion) partagent souvent un titre générique identique ("... - Default
      // Title" x5) mais ont chacune leur propre photo. Ne fusionner que les entrées
      // strictement identiques (même titre ET même image) évite de les confondre
      // avec de vrais doublons (le même produit remonté via 2 collections Shopify).
      const key = p.t + '|' + p.i;
      if (seen.has(key)) continue;
      seen.add(key);
      result.push({ ...p, srcCat });
    }
  }
  return result;
}

/* Fallback SKU-based (produits avec SKU PKMN-NOM-025-VAR) */
let _genImgByNum = null;
function getGenImg(catId, num) {
  if (!window.GEN_IMGS) return null;
  if (!_genImgByNum) {
    _genImgByNum = new Map();
    const SPECIAL_RE = /^(TRANS|TRANSPARENT|SHINY|BRILLANT|BRILLANTE|CHROMATIQUE|CRYSTAL|CRISTAL|MEGA|MEGAX|MEGAY|GMAX|GIGAMAX|DYNAMAX)$/i;
    for (const [sku, url] of Object.entries(window.GEN_IMGS)) {
      const parts = sku.split('-');
      if (parts[0] !== 'PKMN' || parts.length < 3) continue;
      const n = parseInt(parts[2], 10);
      if (!n || _genImgByNum.has(n)) continue;
      if (parts.slice(3).some(p => SPECIAL_RE.test(p))) continue;
      _genImgByNum.set(n, url);
    }
    for (const [sku, url] of Object.entries(window.GEN_IMGS)) {
      const parts = sku.split('-');
      if (parts[0] !== 'PKMN' || parts.length < 3) continue;
      const n = parseInt(parts[2], 10);
      if (!n || _genImgByNum.has(n)) continue;
      _genImgByNum.set(n, url);
    }
  }
  return _genImgByNum.get(num) || null;
}

/* Client Shopify injecté par collection-page.liquid */
function getUser() { return window.MYPOKEA_CUSTOMER || null; }

/* Clé de stockage propre à chaque client (la collection ne fuit pas d'un compte à l'autre) */
function ownedStorageKey()   { const u = getUser(); return u ? OWNED_BASE   + ":" + u.id : OWNED_BASE; }
function ownedBackupKey()    { const u = getUser(); return u ? OWNED_BACKUP + ":" + u.id : OWNED_BACKUP; }

function loadOwned() {
  const key    = ownedStorageKey();
  const bakKey = ownedBackupKey();
  let arr = [];
  try { arr = JSON.parse(localStorage.getItem(key) || "[]"); } catch {}

  // Récupération depuis la backup si la clé principale est vide
  if (!arr.length) {
    try {
      const bak = JSON.parse(localStorage.getItem(bakKey) || "[]");
      if (bak.length) { arr = bak; localStorage.setItem(key, JSON.stringify(arr)); }
    } catch {}
  }

  // Migration ancienne clé générique → clé par client
  if (!arr.length) {
    try {
      const generic = JSON.parse(localStorage.getItem(OWNED_BASE) || "[]");
      if (generic.length) arr = generic;
    } catch {}
    // Migration v1
    if (!arr.length) {
      try {
        const old = JSON.parse(localStorage.getItem(OLD_OWNED_KEY) || "[]");
        if (old.length) arr = old.map(id => "g1:" + id);
      } catch {}
    }
  }
  return mergePurchases(new Set(arr));
}

function saveOwned(set) {
  const data = JSON.stringify([...set]);
  try { localStorage.setItem(ownedStorageKey(), data); } catch {}
  // Double sauvegarde silencieuse — protège contre la perte de la clé principale
  try { localStorage.setItem(ownedBackupKey(), data); } catch {}
  // Copie serveur (metafield client) — survit à un cache vidé / navigation privée / autre appareil
  pushToServer(set);
}

/* ---------- synchronisation serveur (Cloudflare Worker + metafield client Shopify) ----------
   Le localStorage reste la source instantanée (aucune latence, marche hors-ligne), mais un
   client connecté ne doit JAMAIS pouvoir perdre sa collection à cause d'un cache vidé, d'une
   navigation privée ou d'un changement d'appareil : chaque sauvegarde locale est donc aussi
   poussée vers un metafield client Shopify, et rechargée/fusionnée (jamais écrasée) à l'ouverture. */
const SYNC_WORKER = "https://holy-night-505d.robin-carisey68.workers.dev";
let _syncPushTimer = null;

function pushToServer(set) {
  const user = getUser();
  if (!user) return;
  clearTimeout(_syncPushTimer);
  _syncPushTimer = setTimeout(() => _sendToServer(user, set, /*retry*/ true), 600);
}

function _sendToServer(user, set, retry) {
  fetch(SYNC_WORKER + "/collection", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ customer_id: user.id, owned: [...set] }),
  }).catch(() => {
    // Coupure réseau ponctuelle — une seule tentative de rattrapage, silencieuse
    if (retry) setTimeout(() => _sendToServer(user, set, false), 3000);
  });
}

/* Envoi immédiat (sans attendre le debounce) quand l'onglet passe en arrière-plan ou se ferme —
   navigator.sendBeacon garantit l'envoi même pendant une fermeture d'onglet, contrairement à
   fetch() qui peut être annulé par la navigation. Couvre le cas "je coche puis je ferme tout de
   suite" qu'un debounce classique pourrait manquer. */
function flushToServerNow() {
  const user = getUser();
  if (!user) return;
  clearTimeout(_syncPushTimer);
  const payload = JSON.stringify({ customer_id: user.id, owned: [...colState.owned] });
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(SYNC_WORKER + "/collection", new Blob([payload], { type: "application/json" }));
    } else {
      fetch(SYNC_WORKER + "/collection", { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch {}
}
document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flushToServerNow(); });
window.addEventListener("pagehide", flushToServerNow);

/* Re-synchronisation périodique tant que l'onglet reste ouvert et visible — si un autre appareil
   a coché des Pokémon entre-temps, cet onglet les récupère sans avoir besoin d'être rechargé. */
setInterval(() => { if (document.visibilityState === "visible") syncFromServer(); }, 120000);

async function syncFromServer() {
  const user = getUser();
  if (!user) return;
  try {
    const res = await fetch(SYNC_WORKER + "/collection?customer_id=" + encodeURIComponent(user.id));
    if (!res.ok) return;
    const data = await res.json();
    const serverArr = Array.isArray(data.owned) ? data.owned : [];
    const local = colState.owned;
    let grew = false;
    serverArr.forEach(k => { if (!local.has(k)) { local.add(k); grew = true; } });
    if (grew) {
      // Fusion (union) — jamais un simple remplacement, pour ne perdre ni le local ni le serveur
      try { localStorage.setItem(ownedStorageKey(), JSON.stringify([...local])); } catch {}
      try { localStorage.setItem(ownedBackupKey(), JSON.stringify([...local])); } catch {}
      render();
    }
    // Le local avait des entrées absentes du serveur (nouvel appareil, coupure réseau passée) :
    // on republie l'union complète pour que le serveur rattrape le local.
    if (grew || serverArr.length !== local.size) pushToServer(local);
  } catch (e) { /* hors-ligne ou Worker indisponible — la collection reste utilisable en local */ }
}

/* Les achats Shopify (SKU des commandes du client) cochent la collection automatiquement.
   SKU acceptés : clé de collection directe ("g1:25", "shiny:3"),
   clé de forme du Pokédex ("25-kids", "25-shiny", "6-mega"...),
   ou id de la page Spéciales ("shiny-3"). */
function skuToCollectionKey(sku, cats, valid) {
  if (valid.has(sku)) return sku;
  // "<num>-<forme>" : kids → génération ; shiny/mega/gmax/ultra/dx → série spéciale
  let m = sku.match(/^(\d+)-(kids|shiny|mega|gmax|ultra|dx)$/);
  if (m) {
    const num = parseInt(m[1], 10);
    const form = m[2];
    if (form === "kids") {
      const gen = cats.find(c => c.kind === "gen" && num >= c.range[0] && num <= c.range[1]);
      return gen ? gen.id + ":" + num : null;
    }
    const cat = cats.find(c => c.id === form);
    if (cat && cat.figures) {
      const idx = cat.figures.findIndex(f => f.id === num);
      if (idx >= 0) return cat.id + ":" + idx;
    }
    return null;
  }
  // "<série>-<index>" (ancien format page Spéciales)
  m = sku.match(/^(shiny|mega|gmax|ultra|dx)-(\d+)$/);
  if (m) {
    const key = m[1] + ":" + m[2];
    return valid.has(key) ? key : null;
  }
  return null;
}

function mergePurchases(set) {
  const purchased = window.MYPOKEA_PURCHASED || [];
  if (!purchased.length || !window.POKE) return set;
  const cats = POKE.collectionCats() || [];
  const valid = new Set();
  cats.forEach(c => POKE.catItems(c).forEach(it => valid.add(it.key)));
  let changed = false;
  purchased.forEach(sku => {
    const key = skuToCollectionKey(sku, cats, valid);
    if (key && !set.has(key)) { set.add(key); changed = true; }
  });
  if (changed) {
    localStorage.setItem(ownedStorageKey(), JSON.stringify([...set]));
    pushToServer(set); // les Pokémon auto-cochés par un achat doivent aussi remonter au serveur
  }
  return set;
}

let CATS = [];
const colState = { owned: new Set(), catId: null, filter: "all", q: "", mode: 'normal' };

document.addEventListener("DOMContentLoaded", () => {
  try {
    CATS = (window.POKE && POKE.collectionCats) ? POKE.collectionCats() : [];
    colState.owned = loadOwned();
    // Patch les totaux des catégories spéciales sur le vrai catalogue (au lieu du
    // total figé dans SPECIALS) et reporte toute possession cochée via une ancienne
    // clé groupée sur les fiches individuelles correspondantes. Les générations
    // chargées en 2 temps (voir _fetchKantoPage2/_fetchGenPage2) refont cette étape
    // via _invalidateCollectionCaches() une fois le 2e lot de produits arrivé.
    _invalidateCollectionCaches();
    colState.catId = CATS[0] && CATS[0].id;
    colState.mode = localStorage.getItem('mypokea-col-mode') || 'normal';
  } catch (e) { console.error('[collection] init:', e); }
  render();
  syncFromServer(); // fusionne avec le metafield client dès l'ouverture (no-op si déconnecté)
  if ((window.KANTO_PRODUCTS_RAW   || []).length >= 250) _fetchKantoPage2();
  if ((window.HOENN_PRODUCTS_RAW   || []).length >= 250) _fetchGenPage2('HOENN',  'hoenn');
  if ((window.SINNOH_PRODUCTS_RAW  || []).length >= 250) _fetchGenPage2('SINNOH', 'mypokea-decouvrez-toutes-les-finger-puppet-pokemon-kids-de-la-region-de-sinnoh');
});
window.onLangChange = () => { if (getUser()) renderDashboard(document.getElementById("col-root"), getUser()); else render(); };

function render() {
  const user = getUser();
  const root = document.getElementById("col-root");
  if (!user) { renderGate(root); return; }
  renderDashboard(root, user);
}

/* ---------- sign-in gate (compte client Shopify) ---------- */
function renderGate(root) {
  const back = encodeURIComponent(location.pathname + location.search);
  root.innerHTML = `
    <div class="signin-gate">
      <div class="signin-pokeball" aria-hidden="true"></div>
      <h1>${t("col.gate.title")}</h1>
      <p>${t("col.gate.lead")}</p>
      <div class="signin-form">
        <a href="/customer_authentication/login?return_to=${back}" class="btn btn-primary btn-xl">
          Se connecter ou créer un compte
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
        </a>
        <span class="signin-note">Connexion par code email — tu reviens ici automatiquement. Tes achats sur la boutique s'ajoutent tout seuls à ta collection.</span>
      </div>
    </div>
  `;
}

/* ---------- totals ---------- */
function grandTotals() {
  let total = 0, owned = 0;
  // En mode Détaillée, compte les vraies fiches (toutes formes) plutôt que les
  // espèces Pokédex — cohérent avec la bande de catégories (voir renderCatStrip).
  if (colState.mode === 'ultra') {
    const items = _buildDetailItems().items;
    total = items.length;
    owned = items.filter(i => colState.owned.has(i.colKey)).length;
    return { total, owned, pct: total ? Math.round(owned / total * 100) : 0 };
  }
  CATS.forEach(c => {
    total += c.total;
    const items = c.kind === 'special' ? _realSpecialItems(c) : POKE.catItems(c);
    items.forEach(it => { if (_isOwnedAnyForm(it.key)) owned++; });
  });
  return { total, owned, pct: total ? Math.round(owned / total * 100) : 0 };
}
function catOwnedCount(cat) {
  let n = 0;
  const items = cat.kind === 'special' ? _realSpecialItems(cat) : POKE.catItems(cat);
  items.forEach(it => { if (_isOwnedAnyForm(it.key)) n++; });
  return n;
}

/* ---------- dashboard ---------- */
function renderDashboard(root, user) {
  const g = grandTotals();
  const cat = CATS.find(c => c.id === colState.catId) || CATS[0];

  root.innerHTML = `
    <nav class="crumbs" aria-label="Fil d'Ariane">
      <a href="/">${t("nav.home")}</a><span>/</span><span>${t("nav.collection")}</span>
    </nav>

    <section class="col-hero">
      <div class="col-hero-grid">
        <div>
          <div class="col-hello">${t("col.hello")} ${user.name} 👋</div>
          <h1>${t("col.title")} <span>MyPokea</span></h1>
          <p class="col-sub">${t("col.sub")}</p>
          <div class="col-actions">
            <a href="/pages/pokedex" class="btn btn-primary">${t("col.complete")}</a>
            <button class="col-badges-btn" id="col-badges">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M8.5 13.5L7 22l5-3 5 3-1.5-8.5"/></svg>
              Voir mes badges
              <span class="col-badges-count" id="col-badges-count"></span>
            </button>
          </div>
        </div>
        <div class="col-ring-wrap">
          <div class="col-ring">
            <svg viewBox="0 0 200 200">
              <circle class="col-ring-track" cx="100" cy="100" r="84"></circle>
              <circle class="col-ring-fill" id="col-ring-fill" cx="100" cy="100" r="84"></circle>
            </svg>
            <div class="col-ring-center">
              <div class="col-ring-pct" id="col-ring-pct">${g.pct}%</div>
              <div class="col-ring-lbl">${t("col.globalProgress")}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="col-stats">
      <div class="col-stat"><div class="col-stat-num pixel" id="stat-owned">${g.owned}</div><div class="col-stat-lbl">${t("col.owned")}</div></div>
      <div class="col-stat"><div class="col-stat-num pixel" id="stat-missing">${g.total - g.owned}</div><div class="col-stat-lbl">${t("col.missing")}</div></div>
      <div class="col-stat"><div class="col-stat-num pixel">${g.total}</div><div class="col-stat-lbl">${t("col.total")}</div></div>
      <div class="col-stat"><div class="col-stat-num" id="stat-value">0&nbsp;€</div><div class="col-stat-lbl">${t("col.value")}</div></div>
    </div>

    <div class="col-mode-bar">
      <div class="col-mode-switch">
        <button class="col-mode-btn${colState.mode==='normal'?' on':''}" data-mode="normal">
          <span class="col-mode-ic" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="8" height="8" rx="2"/><rect x="13" y="3" width="8" height="8" rx="2"/><rect x="3" y="13" width="8" height="8" rx="2"/><rect x="13" y="13" width="8" height="8" rx="2"/></svg></span>
          <span class="col-mode-txt"><strong>Simplifiée</strong><small>Une case par Pokémon</small></span>
        </button>
        <button class="col-mode-btn${colState.mode==='ultra'?' on':''}" data-mode="ultra">
          <span class="col-mode-ic" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="9" cy="10" r="2"/><path d="m21 15-4.5-4.5a2 2 0 0 0-2.8 0L5 19"/></svg></span>
          <span class="col-mode-txt"><strong>Détaillée</strong><small>Chaque forme, chaque photo</small></span>
        </button>
      </div>
    </div>

    <div class="gen-strip" id="col-cats" aria-label="Catégories"></div>

    <div class="col-nudge" id="col-nudge"></div>

    <div class="col-filters">
      <label class="dex-search">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3-3"/></svg>
        <input type="search" id="col-search" placeholder="${t("col.search")}">
      </label>
      <div class="dex-segment" id="col-seg">
        <button data-f="all" class="${colState.filter==='all'?'on':''}">${t("col.f.all")}</button>
        <button data-f="owned" class="${colState.filter==='owned'?'on':''}">${t("col.f.owned")}</button>
        <button data-f="missing" class="${colState.filter==='missing'?'on':''}">${t("col.f.missing")}</button>
      </div>
    </div>

    <div class="col-draghint">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11V6a2 2 0 0 1 4 0v5M13 7a2 2 0 0 1 4 0v6M17 9a2 2 0 0 1 4 0v5a7 7 0 0 1-7 7h-3a7 7 0 0 1-5-2l-4-4a2 2 0 0 1 3-3l1 1V8a2 2 0 0 1 4 0v3"/></svg>
      Astuce : clique-glisse sur les Pokémon pour en cocher (ou décocher) plusieurs d'un coup.
    </div>

    <div class="col-grid" id="col-grid"></div>
  `;

  document.getElementById("col-badges").onclick = () => openBadges();
  document.getElementById("col-search").addEventListener("input", (e) => { colState.q = e.target.value; renderGrid(); });
  document.querySelectorAll("#col-seg button").forEach(b => b.onclick = () => {
    document.querySelectorAll("#col-seg button").forEach(x => x.classList.remove("on"));
    b.classList.add("on"); colState.filter = b.dataset.f; renderGrid();
  });

  document.querySelectorAll('.col-mode-btn').forEach(btn => {
    btn.onclick = () => {
      colState.mode = btn.dataset.mode;
      localStorage.setItem('mypokea-col-mode', colState.mode);
      // Les deux modes affichent maintenant génération ET catégories spéciales —
      // plus besoin de forcer un retour sur la 1ère génération en changeant de mode.
      document.querySelectorAll('.col-mode-btn').forEach(b => b.classList.toggle('on', b.dataset.mode === colState.mode));
      renderCatStrip();
      updateTotals();
      renderNudge();
      renderGrid();
    };
  });

  renderCatStrip();
  updateTotals();
  renderGrid();
  maybeShowIntro();
}

function renderCatStrip() {
  const root = document.getElementById("col-cats");
  // Générations d'abord, puis catégories spéciales (Shiny, Gigamax...) à la suite —
  // affichées dans les deux modes (Simplifiée et Détaillée). "dx" exclue : aucun
  // flux produit n'est injecté pour cette catégorie sur cette page, l'onglet
  // resterait vide.
  const catsToShow = CATS.filter(c => c.id !== 'dx');
  root.innerHTML = catsToShow.map(c => {
    // En mode Détaillée, "151" (nb d'espèces) n'a pas de sens : chaque forme a sa
    // propre tuile, donc le total réel est bien plus grand. On compte alors les
    // vraies fiches affichées dans cet onglet plutôt que les espèces Pokédex.
    let owned, total;
    if (colState.mode === 'ultra') {
      const items = _detailItemsForCat(c);
      total = items.length;
      owned = items.filter(i => colState.owned.has(i.colKey)).length;
    } else {
      owned = catOwnedCount(c);
      total = c.total;
    }
    const done = total > 0 && owned >= total;
    return `
      <button class="gen-strip-item col-cat ${c.id === colState.catId ? 'active' : ''}" data-cat="${c.id}" style="--cat-color:${c.color};">
        ${c.name}
        <span class="col-cat-count ${done ? 'done' : ''}">${owned}/${total}</span>
      </button>
    `;
  }).join("");
  root.querySelectorAll("[data-cat]").forEach(b => b.onclick = () => {
    colState.catId = b.dataset.cat;
    renderDashboard(document.getElementById("col-root"), getUser());
  });
}

function updateTotals() {
  const g = grandTotals();
  const C = 2 * Math.PI * 84;
  const fill = document.getElementById("col-ring-fill");
  if (fill) { fill.style.strokeDasharray = C; fill.style.strokeDashoffset = C * (1 - g.owned / g.total); }
  const set = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
  set("col-ring-pct", g.pct + "%");
  set("stat-owned", g.owned);
  set("stat-missing", g.total - g.owned);
  // estimated value
  let val = 0;
  CATS.forEach(c => {
    const items = c.kind === 'special' ? _realSpecialItems(c) : POKE.catItems(c);
    items.forEach((it, i) => {
      if (!colState.owned.has(it.key)) return;
      if (c.kind === "gen") { const a = POKE.availability(it.num); val += (a.kidsPrice || 9); }
      else { val += 9; } // pas de prix fiable par produit dans les flux spéciaux — estimation générique
    });
  });
  set("stat-value", Math.round(val) + " €");

  // unlocked badges count on the button
  const bc = document.getElementById("col-badges-count");
  if (bc) {
    const unlocked = collectionBadges().filter(b => b.cur >= b.goal).length;
    bc.textContent = unlocked;
    bc.style.display = unlocked ? "inline-flex" : "none";
  }

  renderNudge();
}

/* ============================================================
   Badges = trophées de progression (cosmétiques, basés sur la
   collection auto-déclarée). Les vraies récompenses (codes promo)
   sont gérées par le programme fidélité, sur les achats réels.
   ============================================================ */
function catCount(id) {
  const c = CATS.find(x => x.id === id);
  return c ? catOwnedCount(c) : 0;
}
function collectionBadges() {
  const g = grandTotals();
  const kanto = catCount("g1");
  const starters = ["g1:1", "g1:4", "g1:7"].filter(k => colState.owned.has(k)).length;
  return [
    { id: "start",  icon: "🎉", color: "var(--grass)", name: "Premiers pas",        desc: "Coche ta 1ʳᵉ pièce",                cur: g.owned, goal: 1 },
    { id: "trio",   icon: "🔥", color: "var(--cherry)", name: "Trio de Kanto",       desc: "Possède les 3 starters de Kanto",   cur: starters, goal: 3 },
    { id: "collec", icon: "📦", color: "var(--sky)",   name: "Collectionneur",       desc: "25 pièces dans ta collection",      cur: g.owned, goal: 25 },
    { id: "half",   icon: "🎯", color: "var(--grape)", name: "Mi-chemin de Kanto",   desc: "76 Pokémon de Kanto",               cur: kanto,   goal: 76 },
    { id: "shiny",  icon: "✦",  color: "var(--sun)",   name: "Chasseur de Shiny",    desc: "5 figurines Shiny",                 cur: catCount("shiny"), goal: 5 },
    { id: "mega",   icon: "🌀", color: "var(--grape)", name: "Méga-collectionneur",  desc: "5 Méga-Évolutions",                 cur: catCount("mega"),  goal: 5 },
    { id: "kanto",  icon: "🏆", color: "var(--sun-deep)", name: "Maître de Kanto",   desc: "Les 151 Pokémon de Kanto",          cur: kanto,   goal: 151 },
    { id: "master", icon: "💎", color: "var(--sky-deep)", name: "Grand Maître",      desc: "50 % du catalogue total",           cur: g.owned, goal: Math.round(g.total * 0.5) },
  ];
}

function ensureBadgeModal() {
  if (document.getElementById("badge-modal")) return;
  const m = document.createElement("div");
  m.id = "badge-modal";
  m.innerHTML = `<div class="bm-backdrop" data-bm-close></div><div class="bm-panel" role="dialog" aria-modal="true"></div>`;
  document.body.appendChild(m);
  m.addEventListener("click", e => { if (e.target.closest("[data-bm-close]")) closeBadges(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeBadges(); });
}
function closeBadges() {
  const m = document.getElementById("badge-modal");
  if (m) m.classList.remove("open");
  document.body.style.overflow = "";
}
function openBadges() {
  ensureBadgeModal();
  const badges = collectionBadges();
  const unlocked = badges.filter(b => b.cur >= b.goal);
  const panel = document.querySelector("#badge-modal .bm-panel");
  panel.innerHTML = `
    <button class="bm-x" data-bm-close aria-label="Fermer">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
    </button>
    <header class="bm-head">
      <span class="eyebrow">Trophées de collection</span>
      <h3>Mes badges</h3>
      <p class="bm-sub">${unlocked.length} trophée${unlocked.length>1?'s':''} débloqué${unlocked.length>1?'s':''} sur ${badges.length}. Complète ta collection pour tous les décrocher. Les codes promo, eux, se gagnent sur tes achats via le programme fidélité.</p>
    </header>
    <div class="bm-body">
      <div class="bm-grid">
        ${badges.map(badgeCard).join("")}
      </div>
      <a href="/account" class="bm-loyalty-link">
        <span>🎁 Voir mes récompenses fidélité (codes promo sur achats)</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
      </a>
    </div>
  `;
  document.getElementById("badge-modal").classList.add("open");
  document.body.style.overflow = "hidden";
}

function badgeCard(b) {
  const got = b.cur >= b.goal;
  const pct = Math.min(100, Math.round(b.cur / b.goal * 100));
  return `
    <div class="bm-badge ${got ? 'got' : 'locked'}" style="--bc:${b.color}">
      <div class="bm-badge-medal">${got ? b.icon : '🔒'}</div>
      <div class="bm-badge-name">${b.name}</div>
      <div class="bm-badge-desc">${b.desc}</div>
      ${got ? `
        <div class="bm-badge-done">✓ Débloqué</div>
      ` : `
        <div class="bm-badge-prog"><div class="bm-badge-bar"><div style="width:${pct}%; background:${b.color};"></div></div>
        <span class="bm-badge-prog-lbl">${b.cur} / ${b.goal}</span></div>
      `}
    </div>
  `;
}

function renderNudge() {
  if (colState.mode === 'ultra') { const n = document.getElementById("col-nudge"); if (n) n.innerHTML = ''; return; }
  const cat = CATS.find(c => c.id === colState.catId);
  const nudge = document.getElementById("col-nudge");
  if (!nudge || !cat) return;
  const owned = catOwnedCount(cat);
  const missing = cat.total - owned;
  const pct = Math.round(owned / cat.total * 100);
  if (owned === 0) {
    nudge.innerHTML = `<span class="col-nudge-ic">✨</span><div><strong>${t("col.nudge.start.t")}</strong><p>${t("col.nudge.start.p")}</p></div><a href="${catLink(cat)}" class="btn btn-sm btn-white">${t("col.browse")}</a>`;
  } else if (missing <= 0) {
    nudge.innerHTML = `<span class="col-nudge-ic">🏆</span><div><strong>${t("col.nudge.done.t")}</strong><p>${t("col.nudge.done.p")}</p></div><a href="/pages/speciales" class="btn btn-sm btn-white">✦</a>`;
  } else {
    nudge.innerHTML = `<span class="col-nudge-ic">🎯</span><div><strong>${t("col.nudge.go.t", {n: missing})}</strong><p>${t("col.nudge.go.p", {pct})}</p></div><a href="${catLink(cat)}" class="btn btn-sm btn-white">${t("col.browse")}</a>`;
  }
}

var GEN_PAGE_HANDLE = { 1: 'pokedex-kanto', 2: 'pokedex-johto', 3: 'pokedex-hoenn', 4: 'pokedex-sinnoh', 5: 'pokedex-unys', 6: 'pokedex-kalos', 7: 'pokedex-alola', 8: 'pokedex-galar', 9: 'pokedex-paldea' };
function catLink(cat) {
  if (cat.kind === "gen") {
    const gen = cat.id.slice(1);
    return GEN_PAGE_HANDLE[gen] ? "/pages/" + GEN_PAGE_HANDLE[gen] : "/pages/pokedex?gen=" + gen;
  }
  return "/pages/speciales?cat=" + cat.id;
}

function priceForItem(it, cat) {
  if (!window.POKE) return null;
  if (cat.kind === "gen") {
    const a = POKE.availability(it.num);
    return a ? (a.kidsPrice || 9) : 9;
  }
  const idx = parseInt(it.key.split(":")[1], 10);
  const spec = POKE.SPECIALS && POKE.SPECIALS.find(s => s.id === cat.id);
  if (!spec) return null;
  return POKE.specialPrice(spec, idx) || null;
}


function renderGrid() {
  const root = document.getElementById("col-grid");
  if (!root || !window.POKE) { if (root) root.innerHTML = ''; return; }
  if (colState.mode === 'ultra') { renderDetailGrid(root); return; }
  const cat = CATS.find(c => c.id === colState.catId) || CATS[0];
  if (!cat) { root.innerHTML = ''; return; }
  renderNormalGrid(root, cat);
}

function renderUltraGrid(root, cat) {
  root.classList.remove('col-grid--normal');
  let list = POKE.catItems(cat);
  if (colState.q.trim()) {
    const q = colState.q.trim().toLowerCase();
    list = list.filter(it => it.label.toLowerCase().includes(q) || String(it.num).includes(q));
  }
  if (colState.filter === "owned") list = list.filter(it => colState.owned.has(it.key));
  if (colState.filter === "missing") list = list.filter(it => !colState.owned.has(it.key));

  if (!list.length) { root.innerHTML = `<div class="col-empty" style="grid-column:1/-1;">${t("col.none")}</div>`; return; }

  root.innerHTML = list.map(it => {
    const owned = colState.owned.has(it.key);
    const src = (cat.kind === 'gen' ? _colFindImg(it.label, it.num) : null) || it.art || '';
    const fallback = (src && src !== it.art) ? (it.art || '') : '';
    const media = src
      ? `<img src="${src}" alt="${_altStd(it.label, it.num)}" loading="lazy"${fallback ? ` onerror="this.onerror=null;this.src='${fallback}'"` : ''}>`
      : `<div class="col-noart" aria-hidden="true">?</div>`;
    return `
      <div class="col-tile ${owned ? 'owned' : ''}" data-key="${it.key}" title="${it.label}">
        <span class="col-check" aria-hidden="true"></span>
        <span class="col-num">#${String(it.num).padStart(3,'0')}</span>
        ${media}
        <div class="col-name">${it.label}</div>
      </div>
    `;
  }).join("");

  bindColDragSelect(root);
}

/* N'est plus appelée que pour les générations (cat.kind === 'gen') — les catégories
   spéciales passent désormais par _realSpecialItems(), déjà résolu avec de vraies
   photos et sans ce mécanisme d'expansion. */
function _expandForNormal(it, cat) {
  if (!MULTI_FORM_NUMS.has(it.num)) return [{ ...it, fullLabel: it.label, variant: '', imgUrl: null }];
  // Cherche dans TOUTES les collections (gen + spéciales) pour trouver chaque forme
  const matches = _buildAllProductsRaw()
    .filter(p => { const m = p.t.match(/N[°º]\s*0*(\d+)/i); return p.i && m && parseInt(m[1], 10) === it.num; })
    .sort((a, b) => a.t.localeCompare(b.t));
  if (matches.length <= 1) return [{ ...it, fullLabel: it.label, variant: '', imgUrl: matches[0] ? matches[0].i : null }];
  return matches.map((p, idx) => {
    const vm = p.t.match(/[—–]\s*(.+)/);
    let variant = vm ? vm[1].trim().replace(/\s*N[°º]\s*\d+\s*$/, '').trim() : '';
    if (it.label && variant.toLowerCase().startsWith(it.label.toLowerCase())) variant = variant.slice(it.label.length).trim();
    const fullLabel = variant ? `${it.label} ${variant}` : it.label;
    return { ...it, key: idx === 0 ? it.key : (it.key + '-' + idx), imgUrl: p.i, variant, fullLabel };
  });
}

function renderNormalGrid(root, cat) {
  root.classList.add('col-grid--normal');
  // Catégories spéciales : reconstruites depuis les vrais produits Shopify
  // (_realSpecialItems), avec la vraie photo déjà résolue — la liste figée
  // POKE.catItems()/_expandForNormal() était incomplète et matchait des photos
  // au hasard (num = position dans la liste, pas un vrai n° Pokédex).
  let list = cat.kind === 'special'
    ? _realSpecialItems(cat)
    : POKE.catItems(cat).flatMap(it => _expandForNormal(it, cat));
  if (colState.q.trim()) {
    const q = colState.q.trim().toLowerCase();
    list = list.filter(it => it.fullLabel.toLowerCase().includes(q) || String(it.num).includes(q));
  }
  if (colState.filter === "owned")   list = list.filter(it =>  _isOwnedAnyForm(it.key));
  if (colState.filter === "missing") list = list.filter(it => !_isOwnedAnyForm(it.key));

  if (!list.length) { root.innerHTML = `<div class="col-empty" style="grid-column:1/-1;">${t("col.none")}</div>`; return; }

  root.innerHTML = list.map(it => {
    const owned = _isOwnedAnyForm(it.key);
    const src = it.imgUrl || _colFindImg(it.label, it.num) || it.art || '';
    const fallback = (src && src !== it.art) ? (it.art || '') : '';
    const media = src
      ? `<img src="${src}" alt="${_altStd(it.fullLabel, it.num)}" loading="lazy"${fallback ? ` onerror="this.onerror=null;this.src='${fallback}'"` : ''}>`
      : `<div class="col-noart" aria-hidden="true">?</div>`;
    return `
      <div class="col-tile${owned ? ' owned' : ''}" data-key="${it.key}" title="${it.fullLabel}">
        <span class="col-check" aria-hidden="true"></span>
        <span class="col-num">#${String(it.num).padStart(3,'0')}</span>
        ${media}
        <div class="col-name">${it.label}</div>
      </div>
    `;
  }).join("");

  bindColDragSelect(root);
}

/* Infos partagées num Pokédex → label FR / génération, construites une seule fois
   (utilisées par le mode Détaillée ET par la reconstruction des catégories
   spéciales à partir des vrais produits). */
let _numGenInfoCache = null;
function _numGenInfo() {
  if (_numGenInfoCache) return _numGenInfoCache;
  const numToLabel = new Map();
  const genColorFromId = {};
  CATS.forEach(c => {
    if (c.kind !== 'gen') return;
    POKE.catItems(c).forEach(it => { if (!numToLabel.has(it.num)) numToLabel.set(it.num, it.label); });
    genColorFromId[c.id] = c.color;
  });
  const numToGenId = (num) => {
    for (const c of CATS) {
      if (c.kind === 'gen' && num >= c.range[0] && num <= c.range[1]) return c.id;
    }
    return null;
  };
  _numGenInfoCache = { numToLabel, genColorFromId, numToGenId };
  return _numGenInfoCache;
}

/* Reconstruit la liste d'une catégorie spéciale (Shiny, Gigamax...) à partir des
   VRAIS produits Shopify réellement tagués pour cette catégorie (srcCat), au lieu
   de la liste figée à la main dans SPECIALS (souvent incomplète et désynchronisée
   du vrai catalogue). Une tuile par espèce (Simplifiée = une case par Pokémon),
   avec sa vraie photo. Clé = catId:pokeNum (ex. "shiny:194") — indépendante de la
   forme normale ("g3:194") et des autres formes spéciales du même Pokémon : cocher
   un Gobou Shiny ne coche pas le Gobou normal ni un éventuel Gobou Gigamax. Cette
   même tuile, vue depuis l'onglet de sa génération (qui affiche toutes les formes),
   utilise exactement la même clé et reste donc synchronisée avec l'onglet spécial. */
let _realSpecialItemsCache = new Map();
function _realSpecialItems(cat) {
  if (_realSpecialItemsCache.has(cat.id)) return _realSpecialItemsCache.get(cat.id);
  const { numToLabel, numToGenId } = _numGenInfo();
  const byNum = new Map(); // pokeNum → { num, label, imgUrl }
  for (const p of _buildAllProductsRaw()) {
    if (p.srcCat !== cat.id) continue;
    const m = p.t.match(/N[°º]\s*0*(\d+)/i);
    if (!m) continue; // pas de n° Pokédex (ex. Dresseurs) — non représentable ici
    const num = parseInt(m[1], 10);
    if (!num || byNum.has(num)) continue;
    byNum.set(num, { num, label: numToLabel.get(num) || `N°${String(num).padStart(3, '0')}`, imgUrl: p.i });
  }
  const items = [...byNum.values()].sort((a, b) => a.num - b.num).map(it => {
    // Même règle de clé qu'en mode Détaillée (voir _buildDetailItems) : une
    // vraie forme spéciale a sa propre case ("shiny:194"), indépendante de la
    // forme normale ("g3:194"). "pikachu" n'est pas une vraie forme (juste une
    // collection de figurines normales) : même clé que la génération, pour
    // rester synchronisé avec l'onglet Kanto.
    const key = cat.id === 'pikachu' ? ((numToGenId(it.num) || 'sp') + ':' + it.num) : (cat.id + ':' + it.num);
    return { key, num: it.num, label: it.label, fullLabel: it.label, variant: '', imgUrl: it.imgUrl, art: null };
  });
  _realSpecialItemsCache.set(cat.id, items);
  return items;
}

/* Construit, pour TOUT le catalogue fusionné, la liste de tuiles du mode Détaillée
   avec une clé UNIQUE PAR VRAIE FICHE PRODUIT — pas juste par forme. Plusieurs
   vraies fiches Shopify distinctes existent parfois pour la même espèce ET la même
   forme (ex. plusieurs unités d'occasion d'un Bulbizarre normal, chacune sa propre
   photo) : cocher l'une ne doit cocher qu'elle-même, pas les autres.
   - Clé de base : genId:pokeNum (forme normale) ou srcCat:pokeNum (forme spéciale
     — Shiny, Gigamax...), comme avant : une forme spéciale reste indépendante de
     la forme normale et des autres formes spéciales du même Pokémon.
   - S'il n'existe qu'UNE SEULE fiche pour cette clé de base, la clé finale reste
     cette clé de base telle quelle (aucun changement pour l'immense majorité des
     cas — zéro migration nécessaire).
   - S'il en existe PLUSIEURS, chacune reçoit un suffixe dérivé de SON PROPRE
     contenu (titre+image), jamais de sa position dans un tri — une position
     (#0, #1...) se décale pour tout le monde dès qu'un produit du groupe est
     ajouté ou supprimé côté admin, décochant en cascade des fiches qui n'ont
     pourtant pas bougé. Un suffixe basé sur le contenu reste stable quoi qu'il
     arrive aux autres fiches du groupe.
   Résultat caché (le catalogue ne change pas pendant que la page reste ouverte). */
function _stableSuffix(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return (h >>> 0).toString(36);
}
let _detailItemsCache = null;
function _buildDetailItems() {
  if (_detailItemsCache) return _detailItemsCache;
  const { numToLabel, genColorFromId, numToGenId } = _numGenInfo();
  const raw = [];
  for (const p of _buildAllProductsRaw()) {
    if (!p.i) continue;
    const m = p.t.match(/N[°º]\s*0*(\d+)/i);
    if (!m) {
      // Dresseur / produit sans numéro Pokédex
      const variantMatch = p.t.match(/[—–]\s*(.+)/);
      const label = variantMatch ? variantMatch[1].trim().replace(/\s*N[°º]\s*\d+\s*$/, '').trim() : p.t;
      raw.push({ pokeNum: 99999, baseKey: 'sp:' + p.t.slice(0, 50), imgUrl: p.i, label, variant: '', genColor: '#888', srcCat: p.srcCat, title: p.t, prodId: p.id });
      continue;
    }
    const pokeNum = parseInt(m[1], 10);
    if (!pokeNum) continue;
    const genId = numToGenId(pokeNum);
    // "pikachu" n'est pas une vraie forme alternative (contrairement à Shiny,
    // Gigamax, Méga...) : c'est une collection qui regroupe des figurines Pikachu
    // normales déjà présentes dans sa génération. Cocher une figurine Pikachu
    // depuis l'onglet Pikachu DOIT cocher la même tuile dans l'onglet Kanto, et
    // inversement — donc même clé (genId:pokeNum), pas une clé à part comme les
    // vraies formes spéciales.
    const isSpecialForm = p.srcCat && !/^g\d$/.test(p.srcCat) && p.srcCat !== 'pikachu';
    const baseKey = isSpecialForm ? (p.srcCat + ':' + pokeNum) : (genId ? (genId + ':' + pokeNum) : ('sp:' + pokeNum));
    const baseLabel = numToLabel.get(pokeNum) || '';
    const variantMatch = p.t.match(/[—–]\s*(.+)/);
    let variant = variantMatch ? variantMatch[1].trim().replace(/\s*N[°º]\s*\d+\s*$/, '').trim() : '';
    if (baseLabel && variant.toLowerCase().startsWith(baseLabel.toLowerCase())) {
      variant = variant.slice(baseLabel.length).trim();
    }
    const label = baseLabel || `N°${String(pokeNum).padStart(3, '0')}`;
    const genColor = (genId && genColorFromId[genId]) || '#888';
    raw.push({ pokeNum, baseKey, imgUrl: p.i, label, variant, genColor, srcCat: p.srcCat, title: p.t, prodId: p.id });
  }
  // Toujours un suffixe, même quand une forme n'a qu'une seule fiche aujourd'hui :
  // si on gardait une clé "nue" pour les cas à 1 fiche, en ajouter une 2e plus tard
  // (ex. une nouvelle unité d'occasion mise en vente) aurait changé la clé de la
  // fiche déjà existante — exactement le genre de décalage à ne plus jamais
  // provoquer. L'identifiant Shopify du produit (permanent, ne change jamais,
  // même si le titre ou la photo sont modifiés plus tard) est utilisé en
  // priorité ; un hash du contenu ne sert que de filet si jamais il manque.
  const byBase = new Map();
  raw.forEach(it => { if (!byBase.has(it.baseKey)) byBase.set(it.baseKey, []); byBase.get(it.baseKey).push(it); });
  const items = [];
  const multiBaseKeys = new Set();
  byBase.forEach((group, baseKey) => {
    if (group.length > 1) multiBaseKeys.add(baseKey);
    group.sort((a, b) => a.title.localeCompare(b.title)); // ordre d'affichage seulement, jamais la clé
    group.forEach((it) => {
      const suffix = (it.prodId != null) ? it.prodId : _stableSuffix(it.title + '|' + it.imgUrl);
      items.push({ ...it, colKey: baseKey + '#' + suffix });
    });
  });
  items.sort((a, b) => a.pokeNum !== b.pokeNum ? a.pokeNum - b.pokeNum : (a.title || '').localeCompare(b.title || ''));
  _detailItemsCache = { items, multiBaseKeys };
  return _detailItemsCache;
}

/* Kanto (et d'autres générations) chargent leur catalogue en 2 temps : les 250
   premiers produits tout de suite, le reste un peu après via _fetchKantoPage2 /
   _fetchGenPage2. _buildDetailItems()/_realSpecialItems() mettent leur résultat en
   cache pour éviter de reparcourir tout le catalogue à chaque interaction — sans
   invalidation ce cache se figeait avec seulement les 250 premiers produits et ne
   voyait plus jamais les suivants (des formes semblaient avoir disparu). Appelée
   après qu'un chargement différé ajoute des produits, pour que tout redevienne
   visible, et on rejoue la migration au cas où ces produits révèlent de nouvelles
   fiches multiples pour une forme déjà cochée. */
function _invalidateCollectionCaches() {
  _detailItemsCache = null;
  _realSpecialItemsCache = new Map();
  CATS.forEach(c => { if (c.kind === 'special') c.total = _realSpecialItems(c).length || c.total; });
  if (_migrateMultiListingKeys()) saveOwned(colState.owned);
}

/* "Possédé" au niveau d'une forme (genId:pokeNum ou srcCat:pokeNum), tous modes et
   tuiles confondus : vrai si la clé simple est cochée OU si au moins une des fiches
   individuelles qui la composent (clé suffixée #0, #1...) l'est. Nécessaire pour
   que les compteurs par génération et le mode Simplifiée restent exacts une fois
   qu'une forme a été scindée en plusieurs fiches cochables séparément. */
function _isOwnedAnyForm(baseKey) {
  if (colState.owned.has(baseKey)) return true;
  const prefix = baseKey + '#';
  for (const k of colState.owned) { if (k.startsWith(prefix)) return true; }
  return false;
}

/* DÉSACTIVÉE. Deux tentatives de "corriger automatiquement" une collection après
   un changement de catalogue ont chacune causé un vrai incident (décochages en
   cascade, puis recochage en masse) — aucune magie de migration n'est fiable à
   100 %, et le risque qu'elle se trompe est pire que l'absence de correction.
   Garantie qui reste, elle, bien réelle : chaque fiche a une clé dérivée de SON
   PROPRE contenu (titre+image) — ajouter ou supprimer un produit n'affecte plus
   JAMAIS la clé d'un autre produit (voir _buildDetailItems). Une case ne change
   désormais que si le client clique dessus lui-même, jamais automatiquement. */
function _migrateMultiListingKeys() {
  return false;
}

/* Sous-liste du catalogue Détaillée (toutes formes confondues) pour une catégorie
   donnée : plage de n° Pokédex pour une génération, srcCat exact pour une
   catégorie spéciale. Réutilisé par le rendu de la grille ET par les compteurs
   (bande de catégories, total général) quand le mode Détaillée est actif, pour
   que "X/Y" compte les vraies fiches affichées et pas les espèces Pokédex (151
   n'a pas de sens en Détaillée vu que chaque forme a sa propre tuile). */
function _detailItemsForCat(cat) {
  const all = _buildDetailItems().items;
  if (!cat) return all;
  if (cat.kind === 'gen') return all.filter(i => i.pokeNum >= cat.range[0] && i.pokeNum <= cat.range[1]);
  if (cat.kind === 'special') return all.filter(i => i.srcCat === cat.id);
  return all;
}

/* Mode Détaillée — TOUS les produits de TOUTES les collections sans filtre de gen.
   Chaque fiche produit (normal, shiny, gigamax, transparente…) a sa propre tuile,
   indépendamment cochable. Triés par numéro Pokédex puis titre. */
function renderDetailGrid(root) {
  root.classList.remove('col-grid--normal');

  const activeCat = CATS.find(c => c.id === colState.catId);
  // Pour une génération : plage de n° Pokédex, incluant naturellement toutes les
  // formes (shiny, transparente, gigamax...) puisqu'elles partagent le même n°.
  // Pour une catégorie spéciale : seulement SES produits (ex. Shiny), pas toutes
  // les formes du Pokémon — cohérent avec le mode Simplifiée.
  let list = _detailItemsForCat(activeCat);
  if (colState.q.trim()) {
    const q = colState.q.trim().toLowerCase();
    list = list.filter(i => i.label.toLowerCase().includes(q) || String(i.pokeNum).includes(q));
  }
  if (colState.filter === "owned")   list = list.filter(i =>  colState.owned.has(i.colKey));
  if (colState.filter === "missing") list = list.filter(i => !colState.owned.has(i.colKey));

  if (!list.length) { root.innerHTML = `<div class="col-empty" style="grid-column:1/-1;">${t("col.none")}</div>`; return; }

  root.innerHTML = list.map(({ pokeNum, colKey, imgUrl, label, variant, genColor }) => {
    const owned = colState.owned.has(colKey);
    const dispNum = pokeNum < 99999 ? String(pokeNum).padStart(3, '0') : '';
    return `
      <div class="col-tile ${owned ? 'owned' : ''}" data-key="${colKey}" title="${label}${variant ? ' — ' + variant : ''}">
        <span class="col-check" aria-hidden="true"></span>
        ${dispNum ? `<span class="col-num">#${dispNum}</span>` : ''}
        <img src="${imgUrl}" alt="${_altStd(label, pokeNum < 99999 ? pokeNum : null)}" loading="lazy">
        <div class="col-name">${label}</div>
      </div>
    `;
  }).join("");

  bindColDragSelect(root);
}

/* ============================================================
   Drag-select (multi-tuiles) — glisser pour cocher/décocher.
   Un simple clic/tap sur une tuile = bascule directe.
   ============================================================ */
const colDrag = {
  on: false, mode: null, touched: new Set(),
  bound: false, root: null,
};

function bindColDragSelect(root) {
  colDrag.root = root;
  if (colDrag.bound) return;
  colDrag.bound = true;

  const tileAt = (x, y) => {
    const el = document.elementFromPoint(x, y);
    return el ? el.closest(".col-tile") : null;
  };
  const apply = (tile) => {
    if (!tile || colDrag.touched.has(tile)) return;
    colDrag.touched.add(tile);
    const key = tile.dataset.key;
    if (colDrag.mode === "add") { colState.owned.add(key); tile.classList.add("owned", "just-toggled"); }
    else { colState.owned.delete(key); tile.classList.remove("owned"); tile.classList.add("just-toggled"); }
    setTimeout(() => tile.classList.remove("just-toggled"), 260);
  };
  const startDrag = (tile) => {
    colDrag.on = true; colDrag.touched.clear();
    colDrag.mode = colState.owned.has(tile.dataset.key) ? "remove" : "add";
    document.body.classList.add("col-selecting");
    apply(tile);
  };
  const endDrag = () => {
    if (!colDrag.on) return;
    colDrag.on = false;
    document.body.classList.remove("col-selecting");
    saveOwned(colState.owned);
    updateTotals();
    syncActiveChip();
    if (colState.filter !== "all") renderGrid();
  };

  // —— mouse : drag démarre dès le mousedown
  // Sur mobile, et sur PC à écran tactile, un seul tap déclenche souvent À LA FOIS
  // touchstart ET un mousedown synthétique juste après. Les deux relançaient
  // chacun startDrag() indépendamment : le 2e repartait d'un état déjà coché par
  // le 1er et décidait donc de décocher — la tuile flashait cochée puis décochée
  // quasi instantanément. On ignore tout mousedown qui suit un touchstart de près.
  let _lastTouchTs = 0;
  document.addEventListener("mousedown", (e) => {
    if (Date.now() - _lastTouchTs < 800) return;
    const tile = e.target.closest("#col-grid .col-tile");
    if (!tile) return;
    startDrag(tile);
  });
  window.addEventListener("mousemove", (e) => {
    if (!colDrag.on) return;
    const tile = tileAt(e.clientX, e.clientY);
    if (tile) apply(tile);
  });
  window.addEventListener("mouseup", endDrag);

  // —— touch : drag démarre dès le touchstart
  document.addEventListener("touchstart", (e) => {
    _lastTouchTs = Date.now();
    const tile = e.target.closest("#col-grid .col-tile");
    if (!tile) return;
    if (navigator.vibrate) navigator.vibrate(4);
    startDrag(tile);
  }, { passive: true });
  document.addEventListener("touchmove", (e) => {
    if (!colDrag.on) return;
    const tt = e.touches[0];
    const tile = tileAt(tt.clientX, tt.clientY);
    if (tile) { e.preventDefault(); apply(tile); }
  }, { passive: false });
  document.addEventListener("touchend", endDrag);
  document.addEventListener("touchcancel", endDrag);
}

function syncActiveChip() {
  const chip = document.querySelector(`.col-cat[data-cat="${colState.catId}"] .col-cat-count`);
  if (!chip) return;
  const cat = CATS.find(c => c.id === colState.catId);
  if (!cat) return;
  let n, total;
  if (colState.mode === 'ultra') {
    const items = _detailItemsForCat(cat);
    total = items.length;
    n = items.filter(i => colState.owned.has(i.colKey)).length;
  } else {
    n = catOwnedCount(cat);
    total = cat.total;
  }
  chip.textContent = n + "/" + total;
  chip.classList.toggle("done", total > 0 && n >= total);
}

/* ============================================================
   Intro onboarding — affiché une seule fois (premier accès)
   ============================================================ */
function maybeShowIntro() {
  if (localStorage.getItem(COL_INTRO_KEY)) return;
  setTimeout(openIntro, 500);
}

function openIntro() {
  if (document.getElementById("col-intro-modal")) return;
  const m = document.createElement("div");
  m.id = "col-intro-modal";
  m.innerHTML = `
    <div class="col-intro-bd" id="col-intro-bd"></div>
    <div class="col-intro-panel" role="dialog" aria-modal="true" aria-label="Comment fonctionne la collection">
      <div class="col-intro-head">
        <div class="col-intro-ball" aria-hidden="true"></div>
        <h2>Comment ça marche ?</h2>
        <p>Ta collection MyPokea en 3 gestes</p>
      </div>
      <div class="col-intro-steps">
        <div class="col-intro-step">
          <div class="col-intro-ic">👆</div>
          <div>
            <strong>Un clic = choisir ta forme</strong>
            <p>Clique sur une figurine pour voir toutes ses versions (Shiny, Méga…) et cocher exactement ce que tu possèdes.</p>
          </div>
        </div>
        <div class="col-intro-step">
          <div class="col-intro-ic">✋</div>
          <div>
            <strong>Cliquer-glisser pour sélection rapide</strong>
            <p>Maintiens le clic et fais glisser sur plusieurs tuiles pour les cocher (ou décocher) d'un seul mouvement.</p>
          </div>
        </div>
        <div class="col-intro-step">
          <div class="col-intro-ic">🏆</div>
          <div>
            <strong>Badges & progression automatique</strong>
            <p>Tes achats sur la boutique cochent automatiquement ta collection. Débloque des trophées au fil de ta progression.</p>
          </div>
        </div>
      </div>
      <button class="col-intro-cta" id="col-intro-ok">C'est parti ! →</button>
    </div>
  `;
  document.body.appendChild(m);
  requestAnimationFrame(() => m.classList.add("open"));

  const close = () => {
    localStorage.setItem(COL_INTRO_KEY, "1");
    m.classList.remove("open");
    setTimeout(() => { if (m.parentNode) m.parentNode.removeChild(m); }, 300);
  };
  m.querySelector("#col-intro-ok").onclick = close;
  m.querySelector("#col-intro-bd").onclick = close;
  const escFn = (e) => { if (e.key === "Escape") { close(); document.removeEventListener("keydown", escFn); } };
  document.addEventListener("keydown", escFn);
}

/* ============================================================
   Form picker — sélectionner quelle forme du Pokémon on possède
   ============================================================ */
function getPokeNum(key) {
  const colonIdx = key.indexOf(":");
  const catId = key.slice(0, colonIdx);
  const itemIdx = key.slice(colonIdx + 1);
  const cat = CATS.find(c => c.id === catId);
  if (!cat) return null;
  if (cat.kind === "gen") return parseInt(itemIdx, 10);
  const idx = parseInt(itemIdx, 10);
  const fig = cat.figures && cat.figures[idx];
  return fig ? (fig.id || null) : null;
}

function formsForKey(key) {
  const num = getPokeNum(key);
  if (!num) return null;
  const forms = [];
  CATS.forEach(cat => {
    if (cat.kind === "gen") {
      if (num >= cat.range[0] && num <= cat.range[1]) {
        const itemKey = cat.id + ":" + num;
        forms.push({ key: itemKey, catName: cat.name, catColor: cat.color, art: GENERIC_REAL_FALLBACK_IMG });
      }
    } else if (cat.figures) {
      cat.figures.forEach((f, i) => {
        if (f.id === num) {
          forms.push({ key: cat.id + ":" + i, catName: cat.name, catColor: cat.color, art: GENERIC_REAL_FALLBACK_IMG });
        }
      });
    }
  });
  return forms;
}

function openFormPicker(key) {
  const colonIdx = key.indexOf(":");
  const catId = key.slice(0, colonIdx);
  const itemIdx = key.slice(colonIdx + 1);
  const cat = CATS.find(c => c.id === catId);
  if (!cat) return;
  const items = POKE.catItems(cat);
  const it = items.find(x => x.key === key);
  if (!it) return;

  const forms = formsForKey(key);
  if (!forms || forms.length <= 1) {
    if (colState.owned.has(key)) colState.owned.delete(key);
    else colState.owned.add(key);
    saveOwned(colState.owned);
    updateTotals(); syncActiveChip(); renderGrid();
    return;
  }

  ensureFormPickerModal();
  const num = getPokeNum(key);
  const art = it.art || it.sprite || "";
  const artHtml = art
    ? `<img src="${art}" alt="${_altStd(it.label, num)}" class="fp-art">`
    : `<div class="fp-art fp-art-fb">#${String(num || 0).padStart(3,"0")}</div>`;

  const content = document.getElementById("fp-content");
  content.innerHTML = `
    <div class="fp-head">
      ${artHtml}
      <div class="fp-meta">
        <div class="fp-num">#${String(num || 0).padStart(3,"0")}</div>
        <h3 class="fp-name">${it.label}</h3>
        <p class="fp-sub">Quelles versions possèdes-tu ?</p>
      </div>
    </div>
    <div class="fp-forms" id="fp-forms">
      ${forms.map(f => `
        <label class="fp-form ${colState.owned.has(f.key) ? "checked" : ""}" style="--fc:${f.catColor}" data-fkey="${f.key}">
          <span class="fp-form-chk"></span>
          <span class="fp-form-name">${f.catName}</span>
        </label>
      `).join("")}
    </div>
    <button class="fp-done" id="fp-done">Enregistrer</button>
  `;

  content.querySelectorAll(".fp-form").forEach(lbl => {
    lbl.onclick = () => lbl.classList.toggle("checked");
  });

  document.getElementById("fp-done").onclick = () => {
    content.querySelectorAll(".fp-form").forEach(lbl => {
      const k = lbl.dataset.fkey;
      if (lbl.classList.contains("checked")) colState.owned.add(k);
      else colState.owned.delete(k);
    });
    saveOwned(colState.owned);
    updateTotals(); syncActiveChip(); renderGrid();
    closeFormPicker();
  };

  const m = document.getElementById("form-picker-modal");
  m.classList.add("open");
  document.body.style.overflow = "hidden";
}

function ensureFormPickerModal() {
  if (document.getElementById("form-picker-modal")) return;
  const m = document.createElement("div");
  m.id = "form-picker-modal";
  m.innerHTML = `
    <div class="fp-backdrop" data-fp-close></div>
    <div class="fp-panel" role="dialog" aria-modal="true">
      <button class="fp-x" data-fp-close aria-label="Fermer">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
      <div id="fp-content"></div>
    </div>
  `;
  document.body.appendChild(m);
  m.addEventListener("click", e => { if (e.target.closest("[data-fp-close]")) closeFormPicker(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeFormPicker(); });
}

function closeFormPicker() {
  const m = document.getElementById("form-picker-modal");
  if (!m) return;
  m.classList.remove("open");
  document.body.style.overflow = "";
}
